import React from "react";
import classNames from "classnames";
import { useAggregatedFiltersContext } from "@components/pageHeader/filters/AggregatedFilters/AggregatedFilters.context";

export const FilterTabPanel: React.FC<{
    eventKey: string;
    className?: string;
    children: React.ReactNode;
}> = ({ eventKey, className, children }) => {
    const { activeTab } = useAggregatedFiltersContext();
    if (activeTab !== eventKey) {
        return null;
    }
    return <div className={classNames("tab-pane", className)}>{children}</div>;
};
